import React from 'react'
import { FilterGroup } from './styled'
import Autocomplete from '../ui/autoComplete'
import ClinicSelect from '../form/clinicSelect'
import DateTimeRangeFilters from '../form/dateTimeRangeFilters'

const AppointmentFilterFields = ({
	values,
	setFieldValue,
	errors,
	specialties = [],
	clinics,
	professionals,
	professionalOptionsOverride,
	loadedProfessionalsKey,
	isLoadingProfessionals,
	onChangeSpeciality = () => {},
	onChangeClinic,
	getProfessionalsKey,
	getClinicOptions,
	clinicDisabled = false,
	disableProfessionalFetch = false,
	professionalDisabled,
	hideSpeciality,
	hideProfessional
}) => {
	const professionalsKey = getProfessionalsKey(values.speciality, values.clinicCode)
	const hasLoadedProfessionals = loadedProfessionalsKey === professionalsKey
	const hasProfessionalOverride = Array.isArray(professionalOptionsOverride)
	const professionalOptions = hasProfessionalOverride
		? professionalOptionsOverride
		: hasLoadedProfessionals
		? professionals
		: []

	const hasSelectedClinic = Array.isArray(values.clinic) ? values.clinic.length > 0 : !!values.clinic

	const professionalPlaceholder = !values.speciality
		? 'Primero seleccioná una especialidad'
		: !hasSelectedClinic
		? 'Primero seleccioná una clínica'
		: 'Seleccionar...'

	const isProfessionalDisabled =
		typeof professionalDisabled === 'boolean'
			? professionalDisabled
			: !values.speciality || !hasSelectedClinic

	return (
		<>
			{!hideSpeciality && (
				<FilterGroup>
					<Autocomplete
						label="Especialidad"
						name="speciality"
						value={values.speciality}
						onChange={e => onChangeSpeciality(e.target?.value ?? e, setFieldValue)}
						options={specialties}
					/>
				</FilterGroup>
			)}

			<FilterGroup>
				<ClinicSelect
					label="Clínica / Centro médico"
					name="clinic"
					value={values.clinic}
					onChange={selected => {
						if (clinicDisabled) return
						onChangeClinic(selected, setFieldValue)
					}}
					disabled={clinicDisabled || values.speciality == null || values.speciality === ''}
					options={clinics}
					isMultiSelect
					placeholder={
						clinicDisabled
							? 'Clínica fija para esta búsqueda'
							: values.speciality == null || values.speciality === ''
							? 'Primero seleccioná una especialidad'
							: 'Seleccionar clinica'
					}
				/>
			</FilterGroup>
			{!hideProfessional && (
				<FilterGroup>
					<Autocomplete
						label="Profesional (Opcional)"
						name="professional"
						value={values.professional}
						onChange={e => setFieldValue('professional', e.target?.value || null)}
						onOpenRequest={
							disableProfessionalFetch
								? undefined
								: () => getClinicOptions(values.clinicCode, values.speciality)
						}
						openOnFocus
						isLoading={isLoadingProfessionals}
						options={professionalOptions}
						isClearable
						disabled={isProfessionalDisabled}
						placeholder={professionalPlaceholder}
					/>
				</FilterGroup>
			)}
			<DateTimeRangeFilters values={values} setFieldValue={setFieldValue} errors={errors} />
		</>
	)
}

export default AppointmentFilterFields
